import type { Persona } from "types/Persona";

// Local storage key for the last active persona ID.
export const SELECTED_PERSONA_STORAGE_KEY = "selectedPersonaId";

/**
 * Loads the value for SELECTED_PERSONA_STORAGE_KEY from local storage.
 * Returns `null` if the value was not set or the load failed.
 */
export function loadLastSelectedPersonaId(): Persona["id"] | null {
  let storedPersonaId: null | string = null;
  try {
    storedPersonaId = localStorage.getItem(SELECTED_PERSONA_STORAGE_KEY);
  } catch (error) {
    console.warn(
      "Failed to load selected persona from local storage, using default persona:",
      error
    );
    return null;
  }
  if (storedPersonaId === null) return null;

  // Persona IDs can either be integers or string UUIDs.
  const storedPersonaIdAsNumber = Number(storedPersonaId);
  return Number.isNaN(storedPersonaIdAsNumber)
    ? storedPersonaId
    : storedPersonaIdAsNumber;
}

/**
 * Save personaId to local storage.
 */
export function setLastSelectedPersonaId(personaId: Persona["id"]) {
  try {
    localStorage.setItem(SELECTED_PERSONA_STORAGE_KEY, String(personaId));
  } catch (error) {
    console.warn(
      "Failed to save selected persona to local storage, selectedPersonaId will not change. Error:",
      error
    );
    return null;
  }
}
